import { media } from 'app/assets/styles'
import { BORDER, SPACING } from 'app-v2/design-tokens'
import styled from 'styled-components'
import { colors } from 'shared/assets/styles'
import { IconButton, fonts } from 'app-v2/design-systems'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { Loader } from 'app/common/loader'
import { SendIcon } from 'app/assets/icons'

type TextAreaProps = {
    textAreaRef: any,
    value: string,
    loading: boolean,
    onChange: () => void,
    onSubmit: () => void,
    disabled: boolean,
    disabledInput: boolean
}

export const TextArea = ({
    value,
    textAreaRef,
    loading,
    onChange,
    onSubmit,
    disabled,
    disabledInput
}: TextAreaProps) => {
    const [inputIsFocus, setInputIsFocus] = useState(false)
    const intl = useIntl()

    return (
        <StyledTextCard>
            <StyledInput active={inputIsFocus} disabled={disabledInput}>
                <StyledTextarea
                    onFocus={() => setInputIsFocus(true)}
                    onBlur={() => {
                        setInputIsFocus(false)
                    }}
                    ref={textAreaRef}
                    name={'customerAnswer'}
                    placeholder={intl.formatMessage({
                        id: 'complaint.input.placeholder'
                    })}
                    onChange={onChange}
                    value={value}
                    id="story"
                    name="story"
                    rows="1"
                    disabled={disabledInput}
                />

                <StyledIconButton
                    icon={
                        loading ? (
                            <Loader loading={loading} size={30} />
                        ) : (
                            <SendIcon
                                color={
                                    disabledInput
                                        ? colors.lightBrown
                                        : colors.bbqBrown
                                }
                            />
                        )
                    }
                    disabled={disabled || disabledInput}
                    buttonColor={
                        disabledInput ? colors.veryLightGrey : colors.white
                    }
                    onClick={onSubmit}
                />
            </StyledInput>
        </StyledTextCard>
    )
}

const StyledTextCard = styled.div`
    padding: ${SPACING.XXL};
    background-color: ${colors.white};
    border-radius: 0 0 ${BORDER.RADIUS.S} ${BORDER.RADIUS.S};
`

const StyledInput = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: end;
    justify-content: center;
    gap: ${SPACING.XXS};
    border: ${BORDER.WIDTH.XS} solid
        ${props =>
            props.active
                ? colors.bbqBrown
                : props.disabled
                ? colors.veryLightGrey
                : colors.lightGrey};
    border-radius: 24px;
    padding: ${SPACING.XS} ${SPACING.M};
    box-sizing: border-box;
    ${props => props.disabled && `background-color:${colors.veryLightGrey};`};
`

const StyledTextarea = styled.textarea`
    margin: 0;
    border: 0;
    padding: 0;
    font-family: ${fonts.flameSansRegular};
    resize: none;
    line-height: 20px;
    max-height: 110px;
    align-self: center;
    color: ${colors.bbqBrown};

    &:disabled {
        ${props =>
            props.disabled && `background-color:${colors.veryLightGrey};`};
    }

    &::placeholder {
        color: ${props =>
            props.disabled ? colors.lightGrey : colors.lightBrown};
    }
`

const StyledIconButton = styled(IconButton)`
    padding: 0;

    ${media.xsmall`
           padding: 0 ${SPACING.S};
    `};
`
